import React from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import Div100vh from "react-div-100vh"
import { elementScrollIntoViewPolyfill } from "seamless-scroll-polyfill"
import { ScrollMenu } from "react-horizontal-scrolling-menu"
import { IconButton } from "@material-ui/core"
import Arrows from "../../../components/Icons/Arrows"
import { AboutPath } from "../../../routes"
import CoronationOverview from "./CoronationOverview"
// import { LeftArrow, RightArrow } from "components/DragScroller/arrows"
import useDrag from "../../../components/DragScroller/useDrag"
import "./Scheme.css"
import CoronationView from "./CoronationView"

if (typeof window !== "undefined" && typeof document !== "undefined") {
  elementScrollIntoViewPolyfill()
}

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.7
}

function onWheel(apiObj, ev) {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15

  if (isThouchpad) {
    ev.stopPropagation()
    return
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext()
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev()
  }
}

export default function Scheme() {
  const { dragStart, dragStop, dragMove } = useDrag()
  const handleDrag =
    ({ scrollContainer }) =>
    ev =>
      dragMove(ev, newPos => {
        if (scrollContainer.current) {
          const currentScroll = scrollContainer.current.scrollLeft
          scrollContainer.current.scrollLeft = currentScroll + newPos
        }
      })

  return (
    <Div100vh>
      <motion.div
        className="scheme-container"
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
      >
        <ScrollMenu
          // LeftArrow={LeftArrow}
          // RightArrow={RightArrow}
          onWheel={onWheel}
          onMouseDown={() => dragStart}
          onMouseUp={() => dragStop}
          onMouseMove={handleDrag}
        >
          <CoronationOverview itemId="#1" />
          <CoronationView itemId="#2" />
        </ScrollMenu>
        <Link to={AboutPath} className="back-button">
          <IconButton>
            <Arrows flip={1} />
          </IconButton>
        </Link>
      </motion.div>
    </Div100vh>
  )
}
